<template>
   <div :key="room._id" :index="room._id" v-if="!deleted">
        <el-row class="row-display" type="flex" justify="space-around" :class="{selected: selected}">
            <el-col :span="1" class="pdt-5">
                <el-checkbox v-model="checked" @change="handleChange" size="medium"></el-checkbox>
            </el-col>
            <el-col class="col-display lock-icon" :span="1">
                <IconBase
                    v-if="room.isLocked"
                    :height="16"
                    :width="16"
                    :view-box="`0 0 16 16`"
                    :fill="'#E7E6FA'"
                >
                    <IconLockSmall />
                </IconBase>
                <IconBase
                    v-if="room.password"
                    :height="16"
                    :width="16"
                    :view-box="`0 0 25 25`"
                    :fill="'#E7E6FA'"
                    style="margin-bottom: -5px;"
                >
                    <IconKey />
                </IconBase>
            </el-col>
            <el-col class="col-display" :span="6">
                <!-- eslint-disable-next-line vue/no-mutating-props-->
                <el-input v-model="room.name" :class="{'is-disabled': !room.isVisible}" :disabled="!room.parent"></el-input>
            </el-col>
            <el-col class="col-display" :span="6">
                <!-- eslint-disable-next-line vue/no-mutating-props -->
                <el-input v-model="room.topic" placeholder="Enter topic name" :class="{'is-disabled': !room.isVisible}"></el-input>
            </el-col>
            <el-col class="col-display room-limit" :span="4">
                <el-input
                    v-model="roomLimit"
                    :class="{ 'is-disabled': !room.isVisible }"
                    :disabled="!room.parent"
                    @blur="onFocusOut"
                    :controls="false"
                    @input="handleRoomLimit"
                ></el-input>
                <div v-if="!!errorMessage" class="icon-info">
                    <IconBase :height="15" :width="15" :view-box="`0 0 15 15`">
                        <IconInfo />
                    </IconBase>
                </div>
                <div v-if="!!errorMessage" class="room-limit-info">
                    <RoomLimitWarning :message="errorMessage" />
                </div>
            </el-col>
             <el-col class="col-display" :span="2" v-if="controls['WHITEBOARD']">
                <div class="links-dropdown" :class="{'is-disabled': !room.isVisible}" @click="emitLinkClicked">
                    <IconBase
                        :height="30"
                        :width="30"
                        :view-box="`0 0 40 40`"
                        :fill="hasSharedLinks ? '#50C6DF' : '#1C1C29'"
                    >
                        <IconLink />
                    </IconBase>
                    <IconBase
                        :height="4"
                        :width="10"
                        :view-box="`0 0 10 4`"
                        :fill="hasSharedLinks ? '#50C6DF' : '#1C1C29'"
                        style="position: relative; top: -2px;"
                    >
                        <IconTriangleDown />
                    </IconBase>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Icon from 'vue-awesome/components/Icon';
import IconBase from '../IconBase';
import IconLink from '../icons/IconLink';
import IconTriangleDown from '../icons/IconTriangleDown';
import IconKey from '../icons/IconKey';
import IconLockSmall from '../icons/IconLockSmall';
import IconInfo from '../icons/IconInfo';
import RoomLimitWarning from './RoomLimitWarning';

export default {
    props: ['room', 'selected', 'deleted', 'hasSharedLinks'],
    components: {
        // eslint-disable-next-line vue/no-unused-components
        Icon,
        IconBase,
        IconLink,
        IconTriangleDown,
        IconKey,
        IconLockSmall,
        IconInfo,
        RoomLimitWarning,
    },
    data() {
        return {
            saving: false,
            checked: false,
            errorMessage: '',
            // sharedLink: null,
            roomLimit:
                this.room.expandedRoomParticipantsLimit === 100
                    ? undefined
                    : this.room.expandedRoomParticipantsLimit,
        };
    },
    watch: {
        selected(newValue) {
            this.checked = newValue;
        },
    },
    methods: {
        handleChange() {
            this.$emit('visibility-changed');
        },
        handleRoomLimit(value) {
            this.isParticipantsCountInvalid(value);
            // eslint-disable-next-line vue/no-mutating-props
            this.room.expandedRoomParticipantsLimit = this.roomLimit || 100;
            // if(value>40){
            //     this.room.lastN=process.env.VUE_APP_EXPANDED_VIDEO_MODE;
            // }
        },
        emitLinkClicked() {
            this.$emit('link-clicked');
        },
        isParticipantsCountInvalid(inputLimit) {
            if (!inputLimit) {
                this.errorMessage = '';
            } else if (!this.isNaturalNumber(inputLimit)) {
                this.errorMessage = 'Only number allowed. Minimum participant limit can be set to 1.';
                this.roomLimit=this.room.expandedRoomParticipantsLimit === 100? undefined: this.room.expandedRoomParticipantsLimit;
            } else {
                this.roomLimit = Math.floor(this.roomLimit);
                if (inputLimit > 100) {
                    this.errorMessage ='Maximum 100 participants room allowed per room.';
                    this.roomLimit = 100;
                } else if (inputLimit < this.room.participants.length) {
                    this.errorMessage = 'You cannot set a limit that is less than the current number of participants.';
                    this.roomLimit = this.room.participants.length;
                } else {
                    this.errorMessage = '';
                }
            }
        },
        isNaturalNumber(n) {
            return !isNaN(String(n)) && n > 0 && Math.floor(n) === +n;
        },
        onFocusOut(){
            this.errorMessage ="";
        }
    },
    computed: {
        ...mapState({
            mainRoom: (state) => state.rooms.mainRoom,
            tokens: (state) => state.user.tokens,
            controls: (state) => state.user.controls,
        }),
    },
};
</script>

<style>
.pdt-5 {
    padding-top: 5px;
}
.row-display {
    padding: 10px 16px;
    border-bottom: 1px solid #393752;
}

.row-display.selected {
    background-color: #686899;
}

.col-display {
    word-break: break-all;
    text-align: left;
    margin-left: 15px;
}
.lock-icon {
    font-size: 20px;
    text-align: center;
    padding: 5px;
}
.key-icon {
    fill: #3887fe;
}
.el-input-number {
    width: auto;
}

.links-dropdown {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 32px;
    margin: 0 auto;
    background: #393752;
    border-radius: 3px;
    cursor: pointer;
}

.links-dropdown.is-disabled {
    background: transparent;
}

.room-limit {
    position: relative;
}

.room-limit .icon-info {
    position: absolute;
    right: -20px;
    top: 10px;
}

.room-limit .room-limit-info {
    position: absolute;
    right: 0;
    top: 32px;
    z-index: 9;
}
</style>
